export default function Footer() {
  const currentYear = new Date().getFullYear();

  const menuLinks = [
    { title: '회사소개', href: '#about' },
    { title: 'ISO 인증', href: '#iso-certification' },
    { title: 'ISO 교육', href: '#iso-education' },
    { title: '경영 인증', href: '#management-certification' },
    { title: '기타 인증', href: '#other-certification' },
    { title: '경영 컨설팅', href: '#consulting' },
    { title: '문의하기', href: '#contact' }
  ];

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-8 md:mb-12">
          <div className="col-span-2 md:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6">
              <div className="w-8 h-8 md:w-10 md:h-10 bg-gradient-to-br from-teal-500 to-teal-600 rounded-lg flex items-center justify-center">
                <i className="ri-shield-check-line text-white text-base md:text-xl"></i>
              </div>
              <span className="text-base md:text-xl font-bold">유엔아이파트너스</span>
            </div>
            <p className="text-gray-400 leading-relaxed mb-4 md:mb-6 text-xs md:text-base">
              <span className="hidden md:block">30년의 전문성과 실증된 성공 경험으로 귀사의 지속 가능한 성장을 설계합니다.</span>
              <span className="md:hidden">30년 전문성으로 귀사의 성장을 설계합니다.</span>
            </p>
            <div className="flex gap-2 md:gap-3">
              <a href="#" className="w-8 h-8 md:w-10 md:h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-teal-600 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-base md:text-xl"></i>
              </a>
              <a href="#" className="w-8 h-8 md:w-10 md:h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-teal-600 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-base md:text-xl"></i>
              </a>
              <a href="#" className="w-8 h-8 md:w-10 md:h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-teal-600 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-base md:text-xl"></i>
              </a>
              <a 
                href="https://blog.naver.com/s9526019" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="w-8 h-8 md:w-10 md:h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-teal-600 transition-colors cursor-pointer"
              >
                <i className="ri-quill-pen-line text-base md:text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm md:text-lg font-bold mb-3 md:mb-4">빠른 링크</h4>
            <ul className="space-y-2 md:space-y-3">
              {menuLinks.slice(0, 4).map((link, index) => (
                <li key={index}>
                  <a href={link.href} className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer text-xs md:text-base">
                    {link.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm md:text-lg font-bold mb-3 md:mb-4">서비스</h4>
            <ul className="space-y-2 md:space-y-3">
              {menuLinks.slice(4).map((link, index) => (
                <li key={index}>
                  <a href={link.href} className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer text-xs md:text-base">
                    {link.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-span-2 md:col-span-1">
            <h4 className="text-sm md:text-lg font-bold mb-3 md:mb-4">연락처</h4>
            <ul className="space-y-2 md:space-y-3">
              <li className="flex items-start gap-2 md:gap-3">
                <i className="ri-map-pin-line text-teal-500 mt-0.5 text-sm md:text-base"></i>
                <span className="text-gray-400 text-xs md:text-base">서울특별시 강남구 테헤란로 123</span>
              </li>
              <li className="flex items-start gap-2 md:gap-3">
                <i className="ri-phone-line text-teal-500 mt-0.5 text-sm md:text-base"></i>
                <a href="tel:070-4113-1039" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer text-xs md:text-base">
                  070-4113-1039 / 010-3240-1039
                </a>
              </li>
              <li className="flex items-start gap-2 md:gap-3">
                <i className="ri-mail-line text-teal-500 mt-0.5 text-sm md:text-base"></i>
                <a href="mailto:s9526019@naver.com" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer text-xs md:text-base break-all">
                  s9526019@naver.com
                </a>
              </li>
              <li className="flex items-start gap-2 md:gap-3">
                <i className="ri-time-line text-teal-500 mt-0.5 text-sm md:text-base"></i>
                <span className="text-gray-400 text-xs md:text-base">평일 09:00 - 18:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-6 md:pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-3 md:gap-4">
            <p className="text-gray-400 text-xs md:text-sm text-center md:text-left">
              © {currentYear} 유엔아이파트너스. All rights reserved.
            </p>
            <div className="flex flex-wrap justify-center gap-4 md:gap-6">
              <a href="#" className="text-gray-400 hover:text-teal-400 text-xs md:text-sm transition-colors cursor-pointer">
                개인정보처리방침
              </a>
              <a href="#" className="text-gray-400 hover:text-teal-400 text-xs md:text-sm transition-colors cursor-pointer">
                이용약관
              </a>
              <a 
                href="https://readdy.ai/?ref=logo" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-400 hover:text-teal-400 text-xs md:text-sm transition-colors cursor-pointer"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
